var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "65px",
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0F807FEA-AC04-4073-86F1-98F21A0723C4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MODIFIED-DETAILS",
    transform: "translate(-66.000000, -298.000000)",
    fill: "#696969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(66.000000, 298.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5,6.09375 C47.0837692,6.09375 58.90625,17.9162308 58.90625,32.5 C58.90625,47.0837692 47.0837692,58.90625 32.5,58.90625 C17.9162308,58.90625 6.09375,47.0837692 6.09375,32.5 C6.09375,17.9162308 17.9162308,6.09375 32.5,6.09375 Z M32.5,65 C50.4492544,65 65,50.4492544 65,32.5 C65,14.5507456 50.4492544,0 32.5,0 C14.5507456,0 0,14.5507456 0,32.5 C0,50.4492544 14.5507456,65 32.5,65 Z M22.2167969,22.2167969 C21.0234375,23.4101563 21.0234375,25.3398438 22.2167969,26.5205078 L28.1835938,32.4873047 L22.2167969,38.4541016 C21.0234375,39.6474609 21.0234375,41.5771484 22.2167969,42.7578125 C23.4101562,43.9384766 25.3398438,43.9511719 26.5205078,42.7578125 L32.4873047,36.7910156 L38.4541016,42.7578125 C39.6474609,43.9511719 41.5771484,43.9511719 42.7578125,42.7578125 C43.9384766,41.5644531 43.9511719,39.6347656 42.7578125,38.4541016 L36.7910156,32.4873047 L42.7578125,26.5205078 C43.9511719,25.3271484 43.9511719,23.3974609 42.7578125,22.2167969 C41.5644531,21.0361328 39.6347656,21.0234375 38.4541016,22.2167969 L32.4873047,28.1835938 L26.5205078,22.2167969 C25.3271484,21.0234375 23.3974609,21.0234375 22.2167969,22.2167969 L22.2167969,22.2167969 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhiteIcon);
export default __webpack_public_path__ + "static/media/close-white-icon.dd67a81f33ee262dd4779a9c1af7e78a.svg";
export { ForwardRef as ReactComponent };